import Moment from 'moment'
import { extendMoment } from 'moment-range'
import Vue from 'vue'
import VueMoment from 'vue-moment'


let moment = extendMoment(Moment)
moment.locale('ru')
Vue.use(VueMoment, {
  moment,
})
